import NC from 'nc/NC'
import React from 'react'
import TopBanner from 'shared-components/ad/TopBanner'
import { useTaglessAd } from 'shared-components/hooks/use-tagless-ad'
import ScrollEventsListener from 'shared-components/service/ScrollEventsListener'
import styleUtils from 'shared-components/styles/util.module.css'
import ContentLayout from 'shared-components/ui/ContentLayout'
import Disclaimer from 'shared-components/ui/Disclaimer'
import NewsletterHero from 'shared-components/ui/NewsletterHero'
import PreviewPostLink from 'shared-components/ui/PreviewPostLink'
import { DSNewsletterPage, DSNewslettersLink } from 'shared-definitions/types'
import ArrowLeft from 'shared-svg/ArrowLeft.svg'
import ArrowRight from 'shared-svg/ArrowRight.svg'
import { DSNCAA } from 'types.aa.ds'
import styles from './NewsletterPageTemplate.module.css'

interface NewsletterPageTemplateProps {
  page: DSNewsletterPage<DSNCAA>
}

const ArrowLink: React.FC<{ type: DSNewslettersLink['type'] } & React.PropsWithChildren> = ({
  children,
  type,
}) => (
  <div className={styles.arrowLink}>
    {type === 'next' && <ArrowRight className={styles.arrowIcon} />}
    {type === 'prev' && <ArrowLeft className={styles.arrowIcon} />}
    {children}
  </div>
)

const NewsletterPageTemplate: React.VFC<NewsletterPageTemplateProps> = ({ page }) => {
  useTaglessAd()

  return (
    <>
      <ScrollEventsListener />
      <Disclaimer />
      <TopBanner />
      <div className={styleUtils.wrapper}>
        <ContentLayout className={styles.layout}>
          <NewsletterHero post={page} absoluteLink={page.pagePath} />

          {page.blocks.map((item, index) => (
            <NC key={index} data={item} tpl="text" index={index} />
          ))}

          {page.buttons.map((item, index) => (
            <React.Fragment key={index}>
              <ArrowLink type={item.type}>{item.label}</ArrowLink>
              <PreviewPostLink
                responsive
                className={styleUtils.mobileFull}
                post={item}
                key={index}
                {...item.pLink}
              />
            </React.Fragment>
          ))}
        </ContentLayout>
      </div>
    </>
  )
}

export default NewsletterPageTemplate
